import { render, staticRenderFns } from "./WalletBalanceSection.vue?vue&type=template&id=5ccf6cee&"
import script from "./WalletBalanceSection.vue?vue&type=script&lang=js&"
export * from "./WalletBalanceSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports